import { AccountInfo } from "@azure/msal-browser";

export enum AuthenticationStage {
    AuthRestoring = "AuthRestoring",
    FreshSignIn = "FreshSignIn",
    SwitchTenant = "SwitchTenant",
}

export class LoggingInMessage {
    public stage: AuthenticationStage;
    public user?: AccountInfo;

    constructor(stage: AuthenticationStage, user?: AccountInfo) {
        this.stage = stage;
        this.user = user;
    }
}